import React from "react";
import style from "../../../containers/treatmentReport.module.scss";
import Spreadsheet from "../../../static/images/ExportSpredsheet.svg";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setTreatmentReportPayload } from "../../../app/woundReportSlice";
import { OVERVIEW_COUNT_CONFIG } from "./treatmentReportConfig";

export const TreatmentOverview = ({ selectedDivOption, setSelectedDivOption }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const treatmentReportPayload = useSelector((state) => state.woundreport.treatmentReportPayload);
  const overViewData = useSelector((state) => state.woundreport.treatmentOverViewData);

  const treatmentPdfPage = () => {
    history.push("/treatmentReport/pdfdownload");
  };

  const optionSelected = (e) => {
    setSelectedDivOption(e);
    const reportPayloadPayload = { ...treatmentReportPayload, optionSelected: e };
    dispatch(setTreatmentReportPayload({ ...reportPayloadPayload, optionSelected: e }));
    const wountCountPayload = { ...treatmentReportPayload, optionSelected: e };
    setTreatmentReportPayload(wountCountPayload);
  };

  return (
    <div className={style.overview_blk}>
      <div className={`${style.overview_top} justify-content-end`}>
        <span className={style.down_spread} onClick={treatmentPdfPage}>
          <img src={Spreadsheet} alt="" />
          <label> Download as PDF </label>
        </span>
      </div>
      <div className={style.overview_score}>
        {OVERVIEW_COUNT_CONFIG.map(({ key, crdClass, dataPath }) => (
          <div
            key={key}
            className={`${crdClass} ${style.overview_percentage} ${selectedDivOption === key ? style.active : ""}`}
            onClick={() => optionSelected(key)}
          >
            <label className={style.dash_top}>{key}</label>
            <p className={style.dash_btm}>
              <span>{overViewData?.[dataPath]?.count ?? 0}</span>
              <span>{overViewData?.[dataPath]?.percent ?? "-"}</span>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
